const envName = process.env.NEXT_PUBLIC_ENV_NAME || 'dev';
export const apiHost = `https://${envName}-api-sc.aberdeencloud01.com`;
